export default function authHeader() {
    const token = localStorage.getItem("access");
    if (token) {
        return { Authorization: "JWT " + token };
    } else {
        return {};
    }
}
